export default "/images/My.svg?fbcd0c9a69e2aff7de8879c2b13a95cc";